import { createMiddleware } from '../../../shared/redux';
import {
    acceptSignIn,
} from '../sign-in/sign-in.state';
import {
    CREATE_PROFILE_REQUEST_SUCCEEDED,
    USER_STATUS_REQUEST_SUCCEEDED,
    requestUserStatus,
} from './create-profile-state';
import { USER_SIGN_UP_PENDING } from '../sign-up/sign-up.constants';
import { promiseTimeout } from './create-profile.utils';
import ROUTES from '../../router/routes.constants';

// TODO: https://github.com/paretogroup/quantic-spa/issues/590
export const createProfileMiddleware = createMiddleware({
    [CREATE_PROFILE_REQUEST_SUCCEEDED]: () => [
        requestUserStatus(),
    ],
    [USER_STATUS_REQUEST_SUCCEEDED]: (state, action) => {
        const { account_status: accountStatus, is_legacy: isLegacy } = action.payload.data;
        if (accountStatus === USER_SIGN_UP_PENDING && !isLegacy) {
            return promiseTimeout(requestUserStatus(), 5000);
        }
        return acceptSignIn({ landingRoute: `${ROUTES.INTEGRATIONS}#onboarding` });
    },
});
